import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'secondsPipe',
})
export class SecondsPipe implements PipeTransform {
    transform(value: number): string {
        switch (value) {
            case 1:
                return 'sekundu';
            case 2:
            case 3:
            case 4:
                return 'sekundy';
            default:
                return 'sekund';
        }
    }
}
